import React, { useMemo } from 'react';

// CONTEXT
import { useRecordContext } from 'helpers/getRecordData';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';
import Card from 'parts/card/Card';

// LOCAL COMPONENTS
import EmployeeCounts from '../view/parts/EmployeeInfo/parts/EmployeeCounts';

// LOCAL VARIABLES
import { EMPLOYEE_OPTION_KEYS, LOOKUP_PARAMS } from '../variables';

// MAIN COMPONETN
const EmployeeInfoForm = () => {

  // CONTEXT
  const { record } = useRecordContext() || {};

  // MEMOS
  const {
    salesman1_site_user_id,
    salesman2_site_user_id,
    salesmanager1_site_user_id,
    salesmanager2_site_user_id,
    number_of_times_sales_manager_1_updated,
    number_of_times_sales_manager_2_updated,
    number_of_times_sales_person_1_updated,
    number_of_times_sales_person_2_updated,
    sales_manager_1_days_diff_between_sales_update,
    sales_manager_2_days_diff_between_sales_update,
    sales_person_1_days_diff_between_sales_update,
    sales_person_2_days_diff_between_sales_update,
  } = useMemo(
    () => record || {},
    [record]
  )

  // RENDER
  return (
    <Form.Body>
      <Form.Select
        name="salesman1_site_user_id"
        label="Salesperson #1"
        lookup="employeeSalesStaff1"
        lookupParams={{
          ...LOOKUP_PARAMS.salesStaff,
          siteUserIdList: salesman1_site_user_id,
        }}
        optionKeys={EMPLOYEE_OPTION_KEYS}
        useNone
        required
        input={{
          append: (
            <EmployeeCounts
              changes={number_of_times_sales_person_1_updated}
              days={sales_person_1_days_diff_between_sales_update}
            />
          )
        }}
      />
      <Form.Select
        name="salesman2_site_user_id"
        label="Salesperson #2"
        lookup="employeeSalesStaff2"
        lookupParams={{
          ...LOOKUP_PARAMS.salesStaff,
          siteUserIdList: salesman2_site_user_id,
        }}
        optionKeys={EMPLOYEE_OPTION_KEYS}
        useNone
        input={{
          append: (
            <EmployeeCounts
              changes={number_of_times_sales_person_2_updated}
              days={sales_person_2_days_diff_between_sales_update}
            />
          )
        }}
      />
      <Form.Select
        name="salesmanager1_site_user_id"
        label="Sales Manager #1"
        lookup="employeeSalesManager1"
        lookupParams={{
          ...LOOKUP_PARAMS.salesManager,
          siteUserIdList: salesmanager1_site_user_id,
        }}
        optionKeys={EMPLOYEE_OPTION_KEYS}
        useNone
        required
        input={{
          append: (
            <EmployeeCounts
              changes={number_of_times_sales_manager_1_updated}
              days={sales_manager_1_days_diff_between_sales_update}
            />
          )
        }}
      />
      <Form.Select
        name="salesmanager2_site_user_id"
        label="Sales Manager #2"
        lookup="employeeSalesManager2"
        lookupParams={{
          ...LOOKUP_PARAMS.salesManager,
          siteUserIdList: salesmanager2_site_user_id,
        }}
        optionKeys={EMPLOYEE_OPTION_KEYS}
        useNone
        input={{
          append: (
            <EmployeeCounts
              changes={number_of_times_sales_manager_2_updated}
              days={sales_manager_2_days_diff_between_sales_update}
            />
          )
        }}
      />
    </Form.Body>
  )
}

// EXPORT
export default function EmployeeInfo(props) {
  return <Card title="Employee Info" body={<EmployeeInfoForm {...props} />} />;
}
